"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = anonymous;

function anonymous(locals, escapeFn, include, rethrow) {
  escapeFn = escapeFn || function (markup) {
    return markup == undefined ? '' : String(markup).replace(_MATCH_HTML, encode_char);
  };

  var _ENCODE_HTML_RULES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&#34;",
    "'": "&#39;"
  },
      _MATCH_HTML = /[&<>'"]/g;

  function encode_char(c) {
    return _ENCODE_HTML_RULES[c] || c;
  }

  ;
  ;
  var __output = "";

  function __append(s) {
    if (s !== undefined && s !== null) __output += s;
  }

  ;

  __append("<div class=\"Image");

  __append(escapeFn(this.isRic ? ' Image--ric' : ''));

  __append(escapeFn(this.isLoading ? ' Image--loading' : ''));

  __append("\">\n    <img alt=\"");

  __append(escapeFn(this.props.alt));

  __append("\" src=\"");

  __append(escapeFn(this.src + this.queryString));

  __append("\" onload=\"this.handleImageLoad(event)\">\n</div>\n");

  return __output;
}